<template>
    <div class="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ isNewStopTemplate ? 'Crear plantilla de parada' : 'Editar plantilla de parada' }}</h5>
                    <button type="button" class="close" @click="closeModal">&times;</button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="handleSubmit">
                        <div class="form-group">
                            <label for="start-time-input">Hora de inicio:</label>
                            <input
                                v-model="formDataStopTemplate.start_time"
                                type="time"
                                id="start-time-input"
                                class="form-control"
                                required
                            />
                        </div>
                        <div class="form-group">
                            <label for="end-time-input">Hora de fin:</label>
                            <input
                                v-model="formDataStopTemplate.end_time"
                                type="time"
                                id="end-time-input"
                                class="form-control"
                                required
                            />
                        </div>
                        <div class="form-group">
                            <label for="description-input">Descripción:</label>
                            <textarea
                                v-model="formDataStopTemplate.description"
                                id="description-input"
                                class="form-control"
                                required
                            ></textarea>
                        </div>
                        <hr>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
                            <button type="submit" class="btn btn-success">Crear</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../common/utils';

export default {
    name: "StopTemplateModal",
    props: {
        formDataStopTemplate: {
            type: Object,
            required: true
        },
        isNewStopTemplate: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            showCreateModal: false,
        };
    },
    methods: {
        handleSubmit() {
            this.isNewStopTemplate ? this.createStopTemplate() : this.updateStopTemplate();
        },
        createStopTemplate() {
            axios.post('/api/stops-template', this.formDataStopTemplate)
                .then(response => {
                    showCustomSuccessSweetAlert('Plantilla de parada del turno creada correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        updateStopTemplate() {
            axios.patch(`/api/stops-template/${this.formDataStopTemplate.id}`, this.formDataStopTemplate)
                .then(response => {
                    showCustomSuccessSweetAlert('Plantilla de parada del turno actualizada correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
    mounted() {
        
    },
};
</script>